/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Styles_Delete_Failed_ToastInputs */

const en_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to delete preset. ${i?.error}`)
};

const fr_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la suppression du preset. ${i?.error}`)
};

const de_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellung konnte nicht gelöscht werden. ${i?.error}`)
};

const it_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare il preset. ${i?.error}`)
};

const ru_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить предустановку. ${i?.error}`)
};

const es_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el ajuste preestablecido. ${i?.error}`)
};

const zh_cn2_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除预设失败。${i?.error}`)
};

const ja_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセットの削除に失敗しました。${i?.error}`)
};

const hi_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट को हटाने में विफल। ${i?.error}`)
};

const pt_pt2_styles_delete_failed_toast = /** @type {(inputs: Styles_Delete_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao excluir a predefinição. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to delete preset. {error}" |
*
* @param {Styles_Delete_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_delete_failed_toast = /** @type {((inputs: Styles_Delete_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Delete_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_delete_failed_toast(inputs)
	if (locale === "de") return de_styles_delete_failed_toast(inputs)
	if (locale === "it") return it_styles_delete_failed_toast(inputs)
	if (locale === "ru") return ru_styles_delete_failed_toast(inputs)
	if (locale === "es") return es_styles_delete_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_delete_failed_toast(inputs)
	if (locale === "ja") return ja_styles_delete_failed_toast(inputs)
	if (locale === "hi") return hi_styles_delete_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_delete_failed_toast(inputs)
	return en_styles_delete_failed_toast(inputs)
});